import React from 'react';

/**
 * FounderBadge — awarded to every launch-era WorldVibe traveler for joining
 * before the doors were fully open. Renders the golden circular badge shipped
 * in `/public/founder-badge.png` — a cosmic-community launch-member medallion.
 *
 * Auto-hides when `active` is false so callers can safely pass
 * `active={user?.is_founder}`.
 *
 * Sizes:  sm = 20px, md = 28px (default), lg = 48px, xl = 88px
 */
export const FOUNDER_BADGE_SRC = '/founder-badge.png';
const SIZES = { sm: 20, md: 28, lg: 48, xl: 88 };

export default function FounderBadge({
  active = true,
  size = 'md',
  className = '',
  title = 'WorldVibe Founder — Launch Member of the Global Community',
  ...rest
}) {
  if (!active) return null;
  const px = SIZES[size] || SIZES.md;
  return (
    <img
      src={FOUNDER_BADGE_SRC}
      alt="Founder"
      width={px}
      height={px}
      title={title}
      data-testid={rest['data-testid'] || 'founder-badge'}
      className={`inline-block shrink-0 select-none ${className}`}
      style={{
        width: px,
        height: px,
        objectFit: 'contain',
        filter: 'drop-shadow(0 0 8px rgba(251,191,36,0.55)) drop-shadow(0 0 14px rgba(34,211,238,0.35))',
      }}
      {...rest}
    />
  );
}
